import axios from "axios";
import { FeedBack } from "../index";

export const ClientFeedbackApi = (formData) => {
  return axios.post(FeedBack, formData);
};
